<template lang="pug">
v-data-table.g-data-table(
  mobile-breakpoint="0",
  v-bind="{ ...$attrs, headers, itemsPerPage, options, footerProps, loading }",
  :items="formattedItems",
  v-on="updatedListeners",
  hide-default-footer,
  :show-expand="collapsable",
  :item-key="itemKey",
  :loading-text="translatedMessage",
)
  template(v-slot:progress="props")
    v-progress-linear(absolute, color="secondary", indeterminate)
  
  template(v-slot:header.data-table-select="{ on, props }")
    v-simple-checkbox(
      color="primary",
      indeterminate-icon="mdi-minus-box-outline",
      on-icon="mdi-check-box-outline",
      v-bind="props",
      v-on="on",
      :ripple="false",
    )
  template(v-slot:item.data-table-select="{ isSelected, select }")
    v-simple-checkbox(
      color="primary",
      indeterminate-icon="mdi-minus-box-outline",
      on-icon="mdi-check-box-outline",
      :value="isSelected",
      @input="select",
      :ripple="false",
    )
  template(v-slot:footer="{ props, on }")
    v-data-footer.g-data-footer(
      prevIcon="$arrowLeftRounded",
      nextIcon="$arrowRightRounded",
      v-on="on"
      v-bind="props",
    )
  slot(v-for="(_, name) in $slots", :name="name", :slot="name")
  template(v-for="(_, name) in $scopedSlots", :slot="name", slot-scope="slotData")
    slot(:name="name" v-bind="slotData")
</template>

<script>
import get from 'lodash/get'
import set from 'lodash/set'
export default {
  name: 'GDataTable',
  props: {
    headers: {
      type: Array,
      default: () => ([]),
    },
    //The headers displayed on the internal table shown at dropdown rows
    subheaders: {
      type: Array,
      default: () => ([]),
    },
    items: {
      type: Array,
      default: () => ([]),
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    collapsable: {
      type: Boolean,
      default: false,
    },
    footerProps: {
      type: Object,
      default: () => ({
        itemsPerPageOptions: [10, 25, 50, 100],
      }),
    },
    itemKey: {
      type: String,
      default: "id"
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      fieldsWithUserTimezone: ['createdAt', 'modifiedAt', 'deletedAt', 'nextResponsibility.deadLine']
    }
  },
  computed: {
    formattedItems() {
      if (this.dateHeaders.length) {
        return this.items.map(i => {
          let itemCopy = { ...i };
          this.dateHeaders.forEach(h => {
            let valueToFormat = get(itemCopy, h.value);
             if(valueToFormat)
             {
               if(this.fieldsWithUserTimezone.includes(h.value)){
                 set(itemCopy,
                  `${h.value}`,
                  this.$dateFormatted(
                      this.$dateTimezoneConvert(
                        valueToFormat,
                        'Etc/GMT',
                        this.userTimezone)
                  )
                );
               }
               else{
                 let itemTz = itemCopy._Entity === 'OrderLine' ? itemCopy.order.ianaTimeZone : itemCopy.ianaTimeZone;

                 set(itemCopy,
                  `${h.value}`,
                  this.$dateFormatted(
                      this.$dateTimezoneConvert(
                        valueToFormat,
                        'Etc/GMT',
                        itemTz)
                  )
                );
               }

             }
          });
          return itemCopy;
        })
      }
      return this.items
    },
    translatedMessage() {
      try{
        return this.$t('Common.loadingTable');
      }
      catch(error)
      {
        return 'Loading... Please wait';
      }
    },
    userTimezone()
    {
      let uTimezone = _.get(this.$store, 'state.user.user.ianaTimeZone', 'Etc/GMT');
      if(uTimezone != null && uTimezone != '') return uTimezone;
      else return 'Etc/GMT';
    },
    dateHeaders() {
      return this.headers.filter(h => h.type === 'DateTime');
    },
    updatedListeners() {
      return Object.assign({}, this.$listeners, {
        'update:options': (event) => {
          const payload = { ...event };
          payload.sortBy = payload.sortBy.map(x => {
            const sortValueHeader = (this.headers.slice().reverse().find(h => h.value === x) || {}).sortValue;
            return sortValueHeader || x;
          });
          this.$emit('update:options', payload)
        }
      })
    },
  },
};
</script>

<style lang="scss">
@import "DataTable.scss";
</style>
